import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import store from './store';
// 1. Define route components.
// These can be imported from other files
import Start from "./views/Start.vue";
import StartPage from "./views/StartPage.vue";
// import Cardlisting from "@/views/Cardlisting.vue";
import Elements from "@/views/Elements.vue";
import Benefits from "@/views/Benefits.vue";
import Team from "@/views/Team.vue";
import ProductView from "@/views/ProductView.vue";

// 2. Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
  { path: "/start", component: Start },
  { path: "/", component: StartPage },
  // { path: "/cardlisting", component: Cardlisting },
  { name: 'product', path: "/product/:id", component: ProductView },
  {
    name: 'qr', path: "/qr/*", redirect: to => {
      store.commit('SET_IS_ONBOARDING_MODAL_ACTIVE', true);
      return to.params.pathMatch;
    }
  },
  { path: "/elements", component: Elements },
  { name: "benefits", path: "/benefits", component: Benefits },
  { name: "words-from-the-team", path: "/words-from-the-team", component: Team },
  { path: '*', redirect: '/' }
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes, // short for `routes: routes`
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {

      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ selector: to.hash })
        }, 300)
      })

    } else {
      return { x: 0, y: 0 }
    }

  }
});

export default router;
